"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Input = require("../form/Input");

var _Input2 = _interopRequireDefault(_Input);

var _SubmitButton = require("../form/SubmitButton");

var _SubmitButton2 = _interopRequireDefault(_SubmitButton);

var _Textarea = require("../form/Textarea");

var _Textarea2 = _interopRequireDefault(_Textarea);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FeedbackForm = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(FeedbackForm, _Component);

  function FeedbackForm() {
    (0, _classCallCheck3.default)(this, FeedbackForm);
    return (0, _possibleConstructorReturn3.default)(this, (FeedbackForm.__proto__ || (0, _getPrototypeOf2.default)(FeedbackForm)).apply(this, arguments));
  }

  (0, _createClass3.default)(FeedbackForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var user = this.props.user;

      if (user) {
        var _props$fields = this.props.fields,
            name = _props$fields.name,
            email = _props$fields.email,
            phone = _props$fields.phone;

        name.onChange(user.first_name + " " + user.last_name);
        email.onChange(user.email);
        phone.onChange(user.phone);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "row" },
        _react2.default.createElement(
          "div",
          { className: "col col-xs-12" },
          _react2.default.createElement(
            "h1",
            { className: "h3" },
            "Anna palautetta"
          ),
          _react2.default.createElement(
            "p",
            null,
            "Haluamme kehitt\xE4\xE4 palveluamme ja arvostamme palautettasi!"
          )
        ),
        this.renderFeedbackForm()
      );
    }
  }, {
    key: "renderFeedbackForm",
    value: function renderFeedbackForm() {
      var _props = this.props,
          _props$fields2 = _props.fields,
          email = _props$fields2.email,
          phone = _props$fields2.phone,
          name = _props$fields2.name,
          message = _props$fields2.message,
          handleSubmit = _props.handleSubmit,
          onSubmit = _props.onSubmit,
          feedback = _props.feedback;

      return _react2.default.createElement(
        "form",
        { id: "feedback", className: "col col-xs-12", onSubmit: handleSubmit(onSubmit) },
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_Input2.default, { id: "name", type: "text", label: "Nimi", subLabel: "(vapaaehtoinen)", fieldProps: name })
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_Input2.default, { id: "phone", type: "text", label: "Puhelinnumero", subLabel: "(vapaaehtoinen)", fieldProps: phone })
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_Input2.default, { id: "email", type: "email", label: "S\xE4hk\xF6posti", fieldProps: email })
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_Textarea2.default, { id: "message", type: "text", label: "Palaute", className: "textarea", fieldProps: message })
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            this.renderErrorMessage(),
            _react2.default.createElement(_SubmitButton2.default, { text: "L\xE4het\xE4", submitting: feedback.sendFeedbackLoading || false })
          )
        )
      );
    }
  }, {
    key: "renderErrorMessage",
    value: function renderErrorMessage() {
      var sendFeedbackError = this.props.feedback.sendFeedbackError;

      if (sendFeedbackError) {
        return _react2.default.createElement(
          "div",
          { className: "col col-xs-12" },
          _react2.default.createElement(
            "p",
            { className: "error-message error-text-js" },
            "Palautteen l\xE4hett\xE4minen ep\xE4onnistui. Yrit\xE4 my\xF6hemmin uudestaan!"
          )
        );
      }
    }
  }]);
  return FeedbackForm;
}(_react.Component), _class.propTypes = {
  fields: _react.PropTypes.object.isRequired,
  handleSubmit: _react.PropTypes.func.isRequired,
  feedback: _react.PropTypes.object.isRequired,
  onSubmit: _react.PropTypes.func.isRequired,
  user: _react.PropTypes.object
}, _temp);
exports.default = FeedbackForm;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/feedback/FeedbackForm.js
 ** module id = 1149
 ** module chunks = 0
 **/